import { resolveDeltaTBucketValue } from './deltaTBucketSelection';

export type ExternalAttrSelection = {
  requestId: number;
  name: string;
  value: string | number;
  mode?: 'direct' | 'deltaTBucket';
};

type SelectionColumn = {
  name: string;
  type?: string | null;
  options?: unknown;
  values?: unknown;
  config?: {
    values?: unknown;
  } | null;
};

type ResolvedSelection = {
  name: string;
  string?: string;
  number?: number;
  date?: string;
};

export const resolveExternalAttrSelection = (
  columns: SelectionColumn[],
  externalAttrSelection: ExternalAttrSelection
): { nextValue: string | number; selection: ResolvedSelection } | null => {
  const column = columns.find(({ name }) => name === externalAttrSelection.name);
  if (!column) {
    return null;
  }

  const nextValue =
    externalAttrSelection.mode === 'deltaTBucket'
      ? resolveDeltaTBucketValue(
          column.config?.values ?? column.values ?? column.options,
          externalAttrSelection.value
        )
      : externalAttrSelection.value;

  if (nextValue === null || nextValue === undefined) {
    return null;
  }

  if (column.type === 'number') {
    const parsedValue = Number(nextValue);
    if (!Number.isFinite(parsedValue)) {
      return null;
    }

    return {
      nextValue,
      selection: {
        name: externalAttrSelection.name,
        number: parsedValue,
      },
    };
  }

  if (column.type === 'date') {
    return {
      nextValue,
      selection: {
        name: externalAttrSelection.name,
        date: String(nextValue),
      },
    };
  }

  if (!column.type || column.type === 'string') {
    return {
      nextValue,
      selection: {
        name: externalAttrSelection.name,
        string: String(nextValue),
      },
    };
  }

  return null;
};
